module.exports = __webpack_public_path__ + "static/wuxing_text-817380193f29ef0cf1018e4a66d25b2e.svg";